import RowsCache from "../jslibs/RowsCache";
import { ISelectRow } from "../libs/dropdown/Dropdown";
import FManApi from "./FManApi";

export type TUsername = ISelectRow<string> 
    
export default class Usernames extends RowsCache<TUsername> {
    static _i:Usernames
    static get i(){
        if (!this._i) this._i = new Usernames()
        return this._i
    }

    constructor(){
        super("unames", 0)
    }

    async fetch(){
        const all = await FManApi.i.getUsernames().then(users => users.map(user => ({label:user.name,value:user._id})))
        all.push({value:"admin",label:"root"})
        all.push({value:"",label:"everyone"})
        return all
    }

    key(row: TUsername): string {
        return row.value
    }
}